export default __webpack_public_path__ + "static/media/wc.2862ff51.png";